import { apiFetch } from './api';

const apiUrl = import.meta.env.VITE_API_URL;

/* Histórico de alterações de um registro: quem criou, quem mudou o quê e quando,
   quem excluiu. API: TDS-Plataform, HistoricoController (GET api/Historico/{entidade}/{id}).
   Estudo e fases: docs/propostas/historico.html. */

export type EntidadeHistorico =
    | 'produto' | 'motivo_perda' | 'tipo_contato' | 'tipo_tarefa' | 'campo_personalizado'
    | 'modelo_documento' | 'organizacao' | 'oportunidade' | 'contato'
    | 'usuario' | 'perfil' | 'equipe'
    | 'agente' | 'conexao' | 'empresa' | 'meta' | 'tarefas_padrao' | 'campanha' | 'template' | 'agenda'
    | 'plano' | 'artigo_ajuda'
    /* Filhos da oportunidade: aparecem no histórico dela, não têm tela própria. */
    | 'tarefa' | 'ligacao' | 'documento';

export interface MudancaHistorico {
    /** Chave estável do campo (`preco`, `etapa`). */
    campo: string;
    /** O nome que a tela mostra. */
    rotulo: string;
    /** Já em texto de tela. Os dois nulos = campo grande demais, a API só diz que mudou. */
    antes: string | null;
    depois: string | null;
}

/** usuario · brik_ai · suporte · ia · canal · integracao · sistema · backfill */
export type OrigemHistorico = 'usuario' | 'brik_ai' | 'suporte' | 'ia' | 'canal' | 'integracao' | 'sistema' | 'backfill';

export interface EventoHistorico {
    id: number;
    entidade: EntidadeHistorico;
    entidadeId: number;
    /** Nome do outro registro quando o evento é dele (a organização vista do contato). */
    entidadeNome: string | null;
    /** criado · editado · excluido · vinculado · desvinculado · (marcos da oportunidade) */
    tipo: string;
    detalhe: string | null;
    mudancas: MudancaHistorico[];
    origem: OrigemHistorico;
    /** Nome de quem fez, só quando foi uma pessoa. */
    autor: string | null;
    em: string;
}

export interface Historico {
    total: number;
    eventos: EventoHistorico[];
}

interface RespostaApi<T> {
    sucesso: boolean;
    mensagem: string;
    dados: T;
}

/* De onde vem o histórico:
   - registro: GET api/Historico/{entidade}/{id} (o normal);
   - tela: GET api/Historico/{entidade} — telas sem ficha (Metas, Tarefas padrão);
   - sistema-empresa: GET api/Historico/sistema/empresa/{id} — a GB Code lendo uma empresa cliente. */
export type FonteHistorico = 'registro' | 'tela' | 'sistema-empresa';

const rota = (entidade: EntidadeHistorico, id: number | undefined, fonte: FonteHistorico) =>
    fonte === 'tela' ? `${entidade}`
        : fonte === 'sistema-empresa' ? `sistema/empresa/${id}`
            : `${entidade}/${id}`;

export const HistoricoService = {
    buscar: async (entidade: EntidadeHistorico, id: number | undefined, limite = 5, fonte: FonteHistorico = 'registro'): Promise<Historico> => {
        const res = await apiFetch(`${apiUrl}/api/Historico/${rota(entidade, id, fonte)}?limite=${limite}`);
        const texto = await res.text();
        /* Rota inexistente numa API antiga devolve 404 vazio. */
        if (!texto) throw new Error(res.status === 404 ? 'A API no ar ainda não tem histórico.' : `Falha ao falar com a API (${res.status}).`);
        const corpo: RespostaApi<Historico> = JSON.parse(texto);
        if (!corpo.sucesso) throw new Error(corpo.mensagem);
        return corpo.dados;
    },
};
